import React from 'react';
import Icon from '../../../components/AppIcon';

const MobileLegend = ({ stablecoinPercentage, m2Percentage }) => {
  const legendItems = [
    {
      id: 'stablecoin',
      label: 'Stablecoins',
      color: '#D08A2A',
      percentage: stablecoinPercentage,
      icon: 'Coins',
      description: 'Digital currencies pegged to fiat'
    },
    {
      id: 'm2',
      label: 'M2 Money Supply',
      color: '#D9D9D9',
      percentage: m2Percentage,
      icon: 'Landmark',
      description: 'Traditional monetary base'
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-5 lg:p-6">
      <h2 className="text-base md:text-lg lg:text-xl font-semibold text-foreground mb-3 md:mb-4 flex items-center gap-2">
        <Icon name="Info" size={20} color="var(--color-primary)" />
        Legend
      </h2>
      <div className="space-y-3 md:space-y-4">
        {legendItems?.map((item) => (
          <div key={item?.id} className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-1">
              <div
                className="w-6 h-6 md:w-7 md:h-7 lg:w-8 lg:h-8 rounded flex items-center justify-center"
                style={{ backgroundColor: item?.color }}
              >
                <Icon
                  name={item?.icon}
                  size={16}
                  color={item?.id === 'stablecoin' ? '#FFFFFF' : '#1A1D23'}
                />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm md:text-base font-medium text-foreground">
                  {item?.label}
                </span>
                <span className="text-lg md:text-xl lg:text-2xl font-bold text-foreground whitespace-nowrap">
                  {item?.percentage?.toFixed(2)}%
                </span>
              </div>
              <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
                {item?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobileLegend;